import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';

const TransitionGroupProps = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element)
	])
};

const TransitionGroupDefault = {
	children: []
};

export class TransitionGroup extends Component {
	state = { newItem: [], removeItems: [], children: [], isMounted: false };
	old = null;
	constructor(props) {
		super(props);
		this.state.children = this.old = Array.isArray(props.children)
			? props.children
			: [props.children];
		this.completelyRemoveItem = this.completelyRemoveItem.bind(this);
		this.coreRendering = this.coreRendering.bind(this);
	}

	completelyRemoveItem() {
		this.setState((state) => {
			const removeItems = [...state.removeItems];
			const removed = removeItems.shift();
			const set = {
				...state,
				removeItems,
				children: state.children.filter((child) => child.key !== removed)
			};
			return set;
		});
	}

	childMap(children) {
		return children.map((child) => child.key);
	}

	componentDidUpdate() {
		const propschild = this.props.children;
		const isSingle = !Array.isArray(propschild);
		const children = isSingle ? [propschild] : propschild;
		const cache = this.state;
		const hasAddedItem = children.length > this.old.length;
		const hasRemoveItem = children.length < this.old.length;
		const isUpdatedChild = children !== this.old;
		const isSingleAndNotSame =
			isSingle && cache.children[0].key !== propschild.key;
		if (isUpdatedChild) this.old = children;

		if (hasRemoveItem || hasAddedItem || isSingleAndNotSame) {
			this.setState((state) => {
			
				let removeItems = []
				let newItems = []
				let updateChildren = children
				if(hasRemoveItem) {
					const currentChild = this.childMap(children);
					removeItems = cache.children.filter(
						(child) =>
							!currentChild.includes(child.key) &&
							!cache.removeItems.includes(child.key)
					);
				}
	
				if(hasAddedItem || isSingleAndNotSame) {
					const previousChild = this.childMap(cache.children);
					newItems = children.filter(
						(child) => !previousChild.includes(child.key)
					); 
					if (removeItems.length && newItems) {
						updateChildren = cache.children
							.map(
								(child) =>
									children.find((fchild) => child.key === fchild.key) || child
							)
							.concat(newItems);
					}
				} else {
					/*to update the childrens if item is removed without added*/
					updateChildren = state.children.map(
						(child) =>
							children.find((fchild) => child.key === fchild.key) || child
					)
				}
				
				return {
					...state,
					removeItems: [
						...state.removeItems,
						...removeItems.map((child) => child.key)
					],
					newItem: [
						...state.newItem, 
						...newItems.map((child) => child.key)
					],
					children: updateChildren
				}
			}); 
		} else {
			const hasNoActivity = !cache.newItem.length && !cache.removeItems.length;
			const hasSameChildrenLength = children.length === cache.children.length;
			const notSameChildren = isSingle
				? isSingleAndNotSame
				: children !== cache.children;
			if (
				cache.isMounted &&
				!(hasAddedItem || hasRemoveItem) &&
				hasNoActivity &&
				hasSameChildrenLength &&
				notSameChildren
			)
				this.setState((state) => ({ ...state, children }));
		}
	}

	componentDidMount() {
		this.setState((prev) => ({ ...prev, isMounted: true }));
	}

	componentWillUnmount() {
		this.setState((prev) => ({ ...prev, isMounted: false }));
	}

	coreRendering(child) {
		const cache = this.state;
		const itIsNew = cache.newItem.includes(child.key);
		const itIsRemove = cache.removeItems.includes(child.key);
		const props = {
			key: child.key,
			in: itIsNew ? false : !itIsRemove,
			stayMountedWhenExited: false
		};

		if (itIsNew) {
			props.onMounted = (node) => {
				child.props.onMounted && child.props.onMounted(node);
				this.setState((state) => {
					const newItem = [...state.newItem];
					newItem.shift();
					return { ...state, newItem };
				});
			};
		}

		if (itIsRemove) {
			props.onExited = (node) => {
				child.props.onExited && child.props.onExited(node);
				this.completelyRemoveItem();
			};
		}

		return cloneElement(child, props);
	}

	render() {
		return <>{this.state.children.map(this.coreRendering)}</>;
	}
}

TransitionGroup.propTypes = TransitionGroupProps;
TransitionGroup.defaultProps = TransitionGroupDefault;
